// Angular
import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';

// WebApi
import {
  VoucherMessageViewDetailsVm as DetailsVm,
  VoucherPostingViewDto as PostingDto,
  VoucherMessageChannelTypeEnum,
  VoucherPostingTypeEnum
} from "../../api";

// App
import { UiActionTypeEnum, UiCommand, UiCommandEvent, UiCommandSourceEnum, UiKeyboardShortcut } from '@ui/cer-ui-types';
import { CerFormPaneType, uiCmdPaneBottomClose, uiCmdPaneBottomToggle, uiCmdPaneRightClose, uiCmdPaneRightToggle } from '@form/cer-form-panes/cer-form-panes.service';
import { FieldMetadata, NavigationCommandMetadata, NavigationCommandQuery, ViewMetadata } from 'src/cer/cer-data/cer-data-types';

// Voucher
import { VoucherDataService } from '../voucher-data.service';
import { VoucherHelper } from '../voucher.service';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView, ICerViewComponent } from '@form/cer-form-view';

@Injectable(
)

export class VoucherPostingViewService {

  constructor(private voucherDataService: VoucherDataService) {
  }

  public componentView: CerFormView;

  // Ui commands
  private uiCmdDetailToggle = Object.assign(new Object(), uiCmdPaneRightToggle, { text: 'Vis vedhæftninger', tooltipText: 'Vis vehæftninger i højre side [Ctrl]+[Pil højre]' });
  private uiCmdBottomToggle = Object.assign(new Object(), uiCmdPaneBottomToggle, { text: 'Vis kontering', tooltipText: 'Vis kontering nederst [Ctrl]+[Pil ned]' });
  private uiCmdDetailClose = Object.assign(new Object(), uiCmdPaneRightClose, { text: '', tooltipText: 'Luk vedhæftninger [Ctrl]+[Pil venstre]' });
  private uiCmdBottomClose = Object.assign(new Object(), uiCmdPaneBottomClose, { text: 'Kontering', tooltipText: 'Luk kontering [Ctrl]+[Pil op]' });

  public keyboardShortcuts: UiKeyboardShortcut[] = [
    { code: 'ArrowRight', ctrl: true, alt: false, shift: false, cmd: this.uiCmdDetailToggle },
    { code: 'ArrowRight', ctrl: true, alt: false, shift: true, cmd: this.uiCmdDetailToggle },
    { code: 'ArrowLeft', ctrl: true, alt: false, shift: false, cmd: this.uiCmdDetailClose },
    { code: 'ArrowLeft', ctrl: true, alt: false, shift: true, cmd: this.uiCmdDetailClose },
    { code: 'ArrowDown', ctrl: true, alt: false, shift: false, cmd: this.uiCmdBottomToggle },
    { code: 'ArrowDown', ctrl: true, alt: false, shift: true, cmd: this.uiCmdBottomToggle },
    { code: 'ArrowUp', ctrl: true, alt: false, shift: false, cmd: this.uiCmdBottomClose },
    { code: 'ArrowUp', ctrl: true, alt: true, shift: true, cmd: this.uiCmdBottomClose }
  ];

  public init() {
    this.manage(this.voucherDataService.setupComplete$.subscribe(ok => this.setup()));
    //this.manage(this.voucherDataService.detailsVm$.subscribe(vm => this.onDetailVm(vm)));
  }

  private subscriptionManager: Subscription = new Subscription();
  private manage(s: Subscription) {
    this.subscriptionManager.add(s);
  }

  ngOnDestroy() {
    this.subscriptionManager.unsubscribe();
  }


  // List support
  public postingView: CerFormView;
  public viewSetGet(pane: CerFormPaneType, parent: ICerViewComponent): CerFormViewSet {
    const viewSet = new CerFormViewSet();
    this.postingView ??= this.postingViewGet();
    this.postingView.paneTarget = pane;
    if (parent != null) {
      this.postingView.dataChild = true;
      this.postingView.dataChildOfIds = [parent.id];
    }
    viewSet.viewAdd(this.postingView, CerFormView.formViewByComponent(parent));
    return viewSet;
  }

  private postingViewGet(): CerFormView {
    const v = VoucherPostingLogic.viewGet(false, false);
    //v.viewMetadata.dataApiName = null; // Auto updates from detail VM
    v.onCommandEvent = (e => this.onCommand(e));
    return v;
  }

  private onDetailVm(vm: DetailsVm): void {
    /*  if (this.postingView) {
        var postingDtoList: PostingDto[] = vm?.voucherPostingViewDtoList ?? [];
  
        var e: UiCommandEvent = <any>{
          source: UiCommandSourceEnum.Event,
          rowsData: postingDtoList,
          actionType: UiActionTypeEnum.DataLoad,
          cancel: false
        };
  
        this.postingView.commandEmit(e);
      }*/
  }

  // Setup view from data service
  private setup() {
    if (!this.postingView) {
      this.postingView = this.postingViewGet();
      var hidePayment: boolean = (
        (this.componentView == null) &&
        (this.voucherDataService.filterChannelType != VoucherMessageChannelTypeEnum.VendorVoucher));

      VoucherPostingLogic.setup(this.postingView.fieldMetadata, hidePayment, this.voucherDataService.filterMyVouchers);
    }
  }

  private onCommand(e: UiCommandEvent): void {
    if (e.actionType == UiActionTypeEnum.QueryCellInfo) {
      VoucherPostingLogic.gridQueryCellInfo(e.args);
    }
    else if (e.source == UiCommandSourceEnum.ActionComplete &&
      e.actionType == UiActionTypeEnum.DataBound) {
      this.enableColumnsDatabound(e);
    }
  }

  private enableColumnsDatabound(e: any) {
    var postingDtoList: PostingDto[] = e.rowData;

    /*
    var vendorBankAccountMissing: boolean = false;

    if (postingDtoList?.length > 0 &&
      this.voucherDataService.filterChannelType == VoucherMessageChannelTypeEnum.VendorVoucher &&
      !this.voucherDataService.filterMyVouchers) {

      vendorBankAccountMissing = postingDtoList?.filter(p => <VoucherPostingTypeEnum>p.postingType == VoucherPostingTypeEnum.Vendor &&
        p.accountNum && !p.vendorBankAccount).length > 0;
    }
    var column = this.grid.grid.getColumnByField('vendorBankAccount');
    if (column?.visible != vendorBankAccountMissing) {
      column.visible = vendorBankAccountMissing;
      this.grid.grid.refreshColumns();
    }
    */
  }
}


/*
var filterApprovalStatusCreate: boolean = this.voucherDataService.filterApprovalStatus == VoucherApprovalStatusAllEnum.Created;
var filterMyApprovals: boolean = this.voucherDataService.filterMyApprovals;
if (filterApprovalStatusCreate && filterMyApprovals) {
  var category = this.fieldMetadataByName('category');
  if (category) {
    category.visible = true;
  }
}

*/

export class VoucherPostingLogic {

  // View
  public static viewMetadata: ViewMetadata = {
    name: 'postering', entityName: 'VoucherPostingView', dataApiName: 'VoucherPostingView', dataApiParams: [],
    text: 'Posteringer', textSingular: 'Postering', titleFields: ['amountCur', 'accountNum'],
    allowEdit: false, allowDelete: false, allowCreate: false,
    parentForeignKey: 'voucherId', parentPrimaryKey: 'id',
    primaryKey: 'id', baseFields: ['id']
  };

  public static fieldMetadata: FieldMetadata[] = [
    { name: 'id', text: "Postering id", format: 'Integer', visible: false, width: '90px' },
    { name: 'voucherId', text: "Bilag id", format: 'Integer', visible: false, width: '90px' },
    { name: 'lineNum', text: "Linjenr.", format: 'Integer', visible: false, width: '90px', orderBy: 'Ascending' },
    { name: 'amountCur', text: "Beløb", format: 'Amount', width: '120px' },
    { name: 'amountCost', text: "Omkostning", format: 'Amount', width: '120px', visible: false },
    { name: 'postingTypeName', text: "Type", width: '80px', foreignKeyUsing: 'accountNum' },
    { name: 'accountNum', text: "Nummer", width: '120px', foreignKey: { onBeforeNavigations: (q => VoucherPostingLogic.postingTypeNavigationQuery(q)) } },
    { name: 'accountDescription', text: "Navn", width: '140px', foreignKeyUsing: 'accountNum' },
    { name: 'isbn', text: "ISBN", width: '120px', visible: false, foreignKeyUsing: 'accountNum' },
    { name: 'projectCostGroup', text: "Gruppe", width: '80px', visible: false },
    { name: 'projectCostTypeDescription', text: "Projektart", width: '80px' },
    { name: 'projectLedgerNumName', text: "Projektbogføring", width: '120px' },
    { name: 'taxCode', text: "Momskode", width: '65px', fieldType: 'financeTaxCode' },
    { name: 'dimension', text: "Afdeling", width: '60px' },
    { name: 'vendorBankAccount', text: "Bankkonto", width: '120px', foreignKeyUsing: 'accountNum' },
    { name: 'paymentRef', text: "Betalings Id", width: '120px' },
    { name: 'txt', text: "Posteringstekst", width: '120px', visible: false },
    { name: 'created', text: "Oprettet", format: 'DateLong', visible: false },
    { name: 'createdByShortName', text: "Oprettet af", width: '100px', visible: false },
    { name: 'modified', text: "Ændret", format: 'DateLong', visible: false },
    { name: 'modifiedByShortName', text: "Ændret af", width: '100px', visible: false }
  ];

  public static toolbarCommands: UiCommand[] = [/*this.uiCmdMainClose*/];

  public static postingTypeNavigationQuery(q: NavigationCommandQuery): NavigationCommandMetadata[] {
    return VoucherPostingLogic.postingTypeNavigation(q.rowData?.postingType ?? q.rowDataSelected?.postingType);
  }

  public static postingTypeNavigation(postingType: VoucherPostingTypeEnum): NavigationCommandMetadata[] {
    switch (postingType) {
      case VoucherPostingTypeEnum.Vendor:
        return [
          { link: 'fk', title: 'Kreditor', foreignKey: { parentEntity: 'VendorView', parentColumn: 'num' } },
          { link: 'fk', title: 'Kreditor (rediger)', foreignKey: { parentEntity: 'Vendor', parentColumn: 'num' } }
        ];
      case VoucherPostingTypeEnum.Project:
      case VoucherPostingTypeEnum.ProjectRoyalty:
        return [{ link: 'fk', foreignKey: { parentEntity: 'RefDataProduct', parentColumn: 'projectNum' } }];
      case VoucherPostingTypeEnum.Bank:
        return [{ link: 'fk', foreignKey: { parentEntity: 'BankAccount', parentColumn: 'name' } }];
      case VoucherPostingTypeEnum.Ledger:
        return [{ link: 'fk', foreignKey: { parentEntity: 'FinanceLedgerAccount', parentColumn: 'num' } }];
    }
    return [];
  }

  public static setup(fields: FieldMetadata[], hidePayment: boolean, myVouchers: boolean) {
    if (myVouchers) {
      VoucherPostingLogic.fieldMetadataByNameHide(fields, 'postingTypeName');
      VoucherPostingLogic.fieldMetadataByNameHide(fields, 'projectLedgerNumName');
      VoucherPostingLogic.fieldMetadataByNameHide(fields, 'taxCode');
      VoucherPostingLogic.fieldMetadataByNameHide(fields, 'dimension');
      hidePayment = true;

      var postingType: FieldMetadata = VoucherPostingLogic.fieldMetadataByName(fields, 'postingType');
      if (postingType) {
        postingType.filterValue = [VoucherPostingTypeEnum.Ledger, VoucherPostingTypeEnum.Project, VoucherPostingTypeEnum.ProjectRoyalty];
        postingType.filterOperator = 'in';
      }
    }
    if (hidePayment) {
      VoucherPostingLogic.fieldMetadataByNameHide(fields, 'vendorBankAccount');
      VoucherPostingLogic.fieldMetadataByNameHide(fields, 'paymentRef');
    }
  }

  private static fieldMetadataByNameHide(fieldMetadata: FieldMetadata[], fieldName: string) {
    var field: FieldMetadata = fieldMetadata.find(f => f.name == fieldName);
    if (field) {
      field.visible = false;
    }
  }

  private static fieldMetadataByName(fieldMetadata: FieldMetadata[], fieldName: string): FieldMetadata {
    return fieldMetadata.find(f => f.name == fieldName);
  }

  public static viewGet(addVoucherNavigation: boolean = false, costVisible: boolean = false): CerFormView {

    const view = new CerFormView();

    view.title = "Kontering";
    view.viewType = 'list';
    view.mandatory = true;
    view.viewMetadata = Object.assign({}, VoucherPostingLogic.viewMetadata);
    if (addVoucherNavigation) {
      view.viewMetadata.navigations = [
        { link: 'nav', foreignKey: { parentEntity: 'Voucher', parentColumn: 'id', column: 'voucherId' } }
      ]
    }

    view.fieldMetadata = VoucherPostingLogic.fieldMetadata;
    if (costVisible) {
      view.fieldMetadata.filter(f => f.name == 'amountCost').forEach(f => f.visible = false);
    }
    view.toolbarCommands = VoucherPostingLogic.toolbarCommands;
    return view;
  }

  public static gridQueryCellInfo(args: any) {
    VoucherHelper.postingGridQueryCellInfo(args);
  }
}
